

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Marketplace.scss';
import { Row, Col, Container } from 'react-bootstrap';
import { COURSES, INSTRUCTORS, KEYWORDS } from './data/Mockdata';
import { fetchCommunities, setSelectedCategory } from '../../store/slices/communitySlice';
import { getCourses, getRecommended, getTrending } from '../../api/marketplace';
import { CourseCard } from './components/CourseCard';
import { ToolsScroller } from './components/ToolsScroller';
import { InstructorCard } from './components/InstructorCard';
import SearchPage from './SearchPage';


const Marketplace = () => {
  const dispatch = useDispatch();
  const { communities, loading, error, filters, categories = [] } = useSelector((state) => state.community);
  const [localCategories, setLocalCategories] = useState([{ _id: '', name: 'All Communities', icon: '🌐' }]);
  const [courses, setCourses] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const [trending, setTrending] = useState([]);
  const [mentorTab, setMentorTab] = useState('courses');

  const [activeKeyword, setActiveKeyword] = useState("Developments");
  const [courseIndex, setCourseIndex] = useState(0);
  const [instructorIndex, setInstructorIndex] = useState(0);

  const VISIBLE_COUNT = 5;

  // Fetch top mentor data
  useEffect(() => {
    getCourses().then(data => setCourses(data?.data || [])).catch(() => setCourses([]));
    getRecommended().then(data => setRecommended(data?.data || [])).catch(() => setRecommended([]));
    getTrending().then(data => setTrending(data?.data || [])).catch(() => setTrending([]));
  }, []);

  // Fetch categories from API (same as Communities page)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch('https://yoospeak.app:5000/categories');
        const data = await res.json();
        if (data && data.data) {
          const apiCategories = data.data.map(cat => {
            const match = cat.name.match(/(.+?)([\u{1F300}-\u{1FAFF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}])?$/u);
            return {
              _id: cat._id,
              name: match ? match[1].trim() : cat.name,
              icon: match && match[2] ? match[2] : '',
            };
          });
          setLocalCategories([{ _id: '', name: 'All Communities', icon: '🌐' }, ...apiCategories]);
        }
      } catch (err) {
        setLocalCategories([{ _id: '', name: 'All Communities', icon: '🌐' }]);
      }
    };
    fetchCategories();
  }, []);

  // Fetch communities when category changes
  useEffect(() => {
    dispatch(fetchCommunities({ category: filters.selectedCategory }));
  }, [dispatch, filters.selectedCategory]);

  const handleCategoryClick = (categoryId) => {
    dispatch(setSelectedCategory(categoryId));
  };

  return (
    <div className="marketplace-page">
      {/* Best Selling Courses */}
      <section className="best-selling-courses-section section-padding">
        <Container fluid="xl">
          <div className="section-heading-wrapper">
            <div className="section-heading">Best selling courses in <span>Web Development</span></div>
            <div className="fs-6 description text-muted">Find the best mentors, courses, and sessions for your needs.</div>
          </div>

          <div className="g-3 g-xxl-4 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
            {COURSES.slice(courseIndex, courseIndex + VISIBLE_COUNT).map((c) => (
              <div className="item-card">
                <CourseCard key={c.id} course={c} />
              </div>
            ))}
          </div>

          {/* Popular Tools + Keywords */}
          <div className="mt-5">
            <ToolsScroller />
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2 mt-4 pt-2">
            <span className="fs-6 fw-semibold text-dark me-1">Popular keyword:</span>
            <span className="d-flex flex-wrap align-items-center gap-2">
            {KEYWORDS.map((kw) => (
              <span
                key={kw}
                className={`small pointer px-3 py-2 ${activeKeyword === kw ? "bg-primary text-white" : "bg-secondary text-dark bg-opacity-10"}`}
                onClick={() => setActiveKeyword(kw)}
              >
                {kw}
              </span>
            ))}
            </span>
          </div>
        </Container>
      </section>

      {/* Popular Instructor */}
      <section className="popular-instructor-section bg-secondary bg-opacity-10 section-padding">
        <Container fluid="xl">
          <div className="section-heading-wrapper">
            <div className="section-heading">Popular instructor in <span>Web Development</span></div>
          </div>

          <div className="g-3 g-xxl-4 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5">
            {INSTRUCTORS.slice(instructorIndex, instructorIndex + VISIBLE_COUNT).map((inst) => (

              <div className="item-card">
                <InstructorCard key={inst.id} instructor={inst} />
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Top Mentors Section */}
      <section className="top-mentor-section section-padding">
        <Container fluid="xl">
          <div className="section-heading-wrapper">
            <div className="section-heading mb-0">Top <span>Mentors</span></div>
          </div>

          {/* Sidebar and Infocard section layout */}
          <SearchPage />

        </Container>
      </section>

      {/* Top Mentors Section */}
      {/* <section className="marketplace-top-mentors top-mentor-section section-padding">
        <div className="section-heading-wrapper">
          <div className="section-heading text-theme1 lh-sm mb-2">Top <span>Mentors</span></div>
        </div>

        <div className="mentor-tabs" style={{ display: 'flex', gap: 16, justifyContent: 'center', marginBottom: 16 }}>
          <button className={mentorTab === 'courses' ? 'active' : ''} onClick={() => setMentorTab('courses')}>Courses</button>
          <button className={mentorTab === 'recommended' ? 'active' : ''} onClick={() => setMentorTab('recommended')}>Recommended</button>
          <button className={mentorTab === 'trending' ? 'active' : ''} onClick={() => setMentorTab('trending')}>Trending</button>
        </div>

        <div className="mentors-list">
          {(mentorTab === 'courses' ? courses : mentorTab === 'recommended' ? recommended : trending).slice(0, 5).map((item, i) => (
            <div className="mentor-card" key={item._id || i}>
              <img src={item.image || `/assets/mentor${i + 1}.jpg`} alt={item.name || item.title || `Mentor ${i + 1}`} />
              <div className="mentor-name">{item.name || item.title || `Mentor ${i + 1}`}</div>
              {item.description && <div className="mentor-desc">{item.description.substring(0, 60)}{item.description.length > 60 ? '...' : ''}</div>}
            </div>
          ))}
        </div>
      </section> */}

      {/* Main Content Section */}
      {/* <section className="marketplace-main">
        <aside className="marketplace-sidebar">
          <h3>Categories</h3>
          <ul className="category-list">
            {localCategories.map(cat => (
              <li
                key={cat._id}
                className={filters.selectedCategory === cat._id ? 'active' : ''}
                style={{ cursor: 'pointer', padding: '0.5rem 0' }}
                onClick={() => handleCategoryClick(cat._id)}
              >
                <span style={{ marginRight: 8 }}>{cat.icon}</span>
                {cat.name}
              </li>
            ))}
          </ul>
        </aside>
        <div className="marketplace-listings">
          {loading ? (
            <div className="text-center py-5">Loading...</div>
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : communities.length === 0 ? (
            <div className="text-center py-5">No communities found.</div>
          ) : (
            communities.map((community) => (
              <div className="listing-card" key={community._id}>
                <img
                  src={community.image || 'https://via.placeholder.com/400x250/6366f1/ffffff?text=Community'}
                  alt={community.name}
                />
                <div className="listing-title">{community.name}</div>
                <div className="listing-meta">
                  {community.members || 0} members
                  {community.price > 0 ? ` • $${community.price}/mo` : ' • Free'}
                </div>
                <div className="listing-description">
                  {community.description?.substring(0, 80)}{community.description?.length > 80 ? '...' : ''}
                </div>
              </div>
            ))
          )}
        </div>
      </section> */}
    </div>
  );
};

export default Marketplace;
